import { Component, OnInit ,Input} from '@angular/core';

@Component({
  selector: 'app-auction-winner',
  templateUrl: './auction-winner.component.html',
  styleUrls: []
})
export class AuctionWinnerComponent implements OnInit {
  @Input() lastPrice :any;
  constructor() { }

  ngOnInit() {

    console.log(this.lastPrice);
    

  }

}
